import React, { createContext, useContext, useState } from 'react';

const OrgContext = createContext({ orgName: '' });

export const OrgProvider = ({ children }) => {
  const [orgName, setOrgName] = useState('');
  return (
    <OrgContext.Provider value={{ orgName, setOrgName }}>
      {children}
    </OrgContext.Provider>
  );
};

export const useOrg = () => useContext(OrgContext);
